import apiClient from '../core';

export const themesApi = {
  // Get all themes (public)
  async list(): Promise<any[]> {
    const response = await apiClient.get<any[]>('/themes');
    return response.data;
  },

  // Get single theme (public)
  async get(themeId: string): Promise<any> {
    const response = await apiClient.get<any>(`/themes/${themeId}`);
    return response.data;
  },

  // Update theme colors (admin only)
  async customize(themeId: string, customColors: any): Promise<any> {
    const response = await apiClient.put<any>(`/themes/${themeId}/customize`, {
      customColors,
    });
    return response.data;
  },

  // Reset theme to defaults (admin only)
  async reset(themeId: string): Promise<any> {
    const response = await apiClient.delete<any>(`/themes/${themeId}/customize`);
    return response.data;
  },

  // Export all customizations (admin only)
  async export(): Promise<any> {
    const response = await apiClient.get<any>('/themes/export');
    return response.data;
  },

  // Import customizations (admin only)
  async import(data: any): Promise<any> {
    const response = await apiClient.post<any>('/themes/import', data);
    return response.data;
  },
};
